<style lang="less" scoped>
.table-expand{
  /deep/label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }
}
/deep/.in-dialog{
  &.el-card{
    margin-bottom: 0;
    height: auto;
  }
  img{
    max-width: 100%;
    max-height: 80vh;
    cursor: default;
  }
  .img-item{
    width: 37.5%!important;
    padding: 5px!important;
  }
  .result-item{
    width: 25%!important;
    padding: 15px!important;
  }
  .result{
    height: 190px;
    margin-bottom: 20px;
    font-size: 30px;
    .mode{
      display: block;
      font-size: 20px;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid white;
      width: 100%;
    }
    .number{
      flex: 1;
      font-size: 40px;
      justify-content: center;
    }
    .content{
      flex: 1;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .label{
      font-size: 30px;
      height: 45px;
    }
  }
  .el-tag{
    font-size: 20px;
    padding: 10px;
  }
}
</style>

<template>
  <div>
      <el-form inline>
        <el-form-item>
          <el-button-group class="overview-buttons">
            <el-button :class="currentSelect==='all'?  'el-button--primary':''" @click="load('all')">全部</el-button>
            <el-button :class="currentSelect==='today'?'el-button--primary':''" @click="load('today')">今天</el-button>
            <el-button :class="currentSelect==='week'? 'el-button--primary':''" @click="load('week')">本周</el-button>
            <el-button :class="currentSelect==='month'?'el-button--primary':''" @click="load('month')">本月</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="timeRange"
            value-format="timestamp"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-select v-model="pageForm.departmentNo" clearable>
            <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行电脑">
          <el-select v-model="pageForm.computerNo" clearable>
            <el-option v-for="item in pcList" :key="item.id" :label="item.name" :value="item.no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息类型">
          <el-select v-model="pageForm.msgCode" clearable>
            <el-option v-for="item in msgList" :key="item.code" :label="item.msg" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="相似度区间(%)" v-if="pageForm.msgCode === 1000">
          <el-input-number v-model="pageForm.minMatchScore" :precision="2" :step="0.01" :max="100" :min="0"></el-input-number>
          -
          <el-input-number v-model="pageForm.maxMatchScore" :precision="2" :step="0.01" :max="100" :min="0"></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="通过率" style="float: right; font-weight: bold;">{{passPercent}}</el-form-item> -->
      </el-form>

      <el-table :data="dataList" size="medium">
        <!-- <el-table-column type="expand">
          <template v-slot="scope" >
            <el-form label-position="left" inline class="table-expand">
              <el-form-item label="对比类型">
                <span>{{ scope.row.route | route_name}}</span>
              </el-form-item>
              <el-form-item label="模式">
                <span>{{ scope.row.compareMode }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column> -->
        <el-table-column type="index" fixed></el-table-column>
        <el-table-column label="服务地址" prop="server" width="155px"></el-table-column>
        <el-table-column label="请求路由" prop="route" width="145px"></el-table-column>
        <el-table-column label="请求IP" prop="caller" width="130px"></el-table-column>
        <el-table-column label="请求电脑">
          <template v-slot="scope">
            {{scope.row.computerNo | computer_name}}
          </template>
        </el-table-column>
        <el-table-column label="所属部门">
          <template v-slot="scope">
            {{scope.row.departmentNo | department_name}}
          </template>
        </el-table-column>

        <el-table-column label="对比类型" width="140px">
          <template v-slot="scope" >
            {{scope.row.route | route_name}}
          </template>
          </el-table-column>
        <el-table-column label="对比模式" width="100px">
          <template v-slot="scope">
            {{scope.row.compareMode.replace("模式","")}}
          </template>
        </el-table-column>
        <el-table-column label="对比结果" width="85px">
          <template v-slot="scope">
            <el-tag type="success" v-if="scope.row.compareResult==='SUCCESS'">
              {{scope.row.matchNumber + '%'}}
            </el-tag>
            <el-tag type="danger" v-else>
              {{scope.row.matchNumber?scope.row.matchNumber+'%':'失败'}}
              <!-- 失败 -->
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="请求时间" width="170px">
          <template v-slot="scope" >
            {{scope.row.createTime | date_time}}
          </template>
        </el-table-column>
         <el-table-column label="接口耗时" width="80px">
          <template v-slot="scope" >
            {{scope.row.spantime}} ms
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100px" fixed="right">
          <template v-slot="scope">
            <!-- <el-popover
              placement="left"
              title="对比详情"
              width="350"
              trigger="click">
              <one-to-one-card :data="scope.row"></one-to-one-card>

              <el-button type="primary" slot="reference">查看详情</el-button>
            </el-popover> -->

            <el-button type="primary" @click="showDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="对比详情" :visible.sync="visible" width="90%" destroy-on-close>
        <one-to-one-card :data="currentObject" class="in-dialog"></one-to-one-card>
      </el-dialog>

      <el-pagination style="text-align: center; "
                     :total="total" :layout="'prev, pager, next, jumper, ->, total'"
                     :current-page="pageForm.page + 1"
                     :page-size="pageForm.size"
                     @current-change="pageChange"
      ></el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
  import OneToOneCard from "@/components/1v1card"
  import moment from "moment";

  export default {
    components: {
      OneToOneCard
    },
    data() {
      return {
        timeRange: '',
        currentSelect: 'all',
        dataList: [],
        statisticsData: {},
        chartData: {},
        total: 0,
        pageForm: {
          computerNo: '',
          departmentNo: '',
          page: 0,
          size: 20,
          startTime: 946656000, //2000-01-01
          endTime: moment().valueOf(),
          msgCode: '',
          minMatchScore:undefined,
          maxMatchScore:undefined
        },
        msgList: [],
        loading: false,
        get passPercent() {
          if(this.statisticsData.total){
            return (this.statisticsData.successCount / this.statisticsData.total * 100).toFixed(2) + '%'
          }

          return '...'
        },
        visible: false,
        currentObject: {}
      }
    },
    computed: {
      ...mapState("computer", {pcList: state => state.list}),
      ...mapState("department", {deptList: state => state.list})
    },
    // filters: {
    //   route_name(v){
    //     switch(v){
    //       case '1vs1/compare': return '人脸对比';
    //       case '6N1/compare':  return '6合1人脸对比';
    //       case '6N1/zz/compare': return '6合1众志人脸对比';
    //       case '122/compare':  return '122人脸对比'
    //     }
    //   }
    // },
    watch: {
      pageForm: {
        handler(v){
          this.loadRecords()
        },
        deep: true
      },
      'pageForm.departmentNo'(v){
        this.pageForm.computerNo = ''
        this.loadPcs(v)
      },
      timeRange (v) {
        if (!v) {
          if(!this.currentSelect){
            this.currentSelect = 'all'
            this.pageForm.startTime = 946656000 //2000-01-01
            this.pageForm.endTime = moment().valueOf()
          }
        } else {
          this.currentSelect = ''
          let [start, end] = v
          this.pageForm.startTime = start
          this.pageForm.endTime = end
        }
      }
    },
    methods: {
      ...mapActions({loadPcs: 'computer/list'}),
      ...mapActions({loadDepts: 'department/list'}),
      load(time){
        //all、today、week、month
        this.currentSelect = time;
        this.timeRange = ''
        if (time==='all') {
          this.pageForm.startTime = 946656000 //2000-01-01
        } else if (time === 'today') {
          this.pageForm.startTime = moment().startOf('date').valueOf()
        } else if (time === 'week') {
          this.pageForm.startTime = moment().startOf('week').valueOf()
        } else if (time === 'month') {
          this.pageForm.startTime = moment().startOf('month').valueOf()
        }
        this.pageForm.endTime = moment().valueOf()
      },
      loadMsg(){
        this.$request(this.$api.record.msglist()).then(res => {
          this.msgList = res
          // console.log(res)
        })
      },
      async loadRecords(){
        this.loading = true;
        let params = {
          ...this.pageForm,
          minMatchScore: this.pageForm.minMatchScore && Number((this.pageForm.minMatchScore/100).toFixed(4)),
          maxMatchScore: this.pageForm.maxMatchScore && Number((this.pageForm.maxMatchScore/100).toFixed(4)),
        }
        let res = await this.$request(this.$api.record.list1vs1(params));  //this.pageForm
        this.dataList = res.list;
        for (let e of res.list) {
          if(e.result[0]==='{'){
            e.result = JSON.parse(e.result);
            if(e.result.message){
              e.result = e.result.message
            }else{
              e.matchNumber = Math.round(e.result.match * 100 * 100)/100;
            }
          }
        }
        this.total = res.total;

        this.loading = false;

        let response = await this.$request(this.$api.record.statistics1vs1(this.pageForm));
        this.statisticsData = response;

        if(this.currentSelect === 'all') {
          this.chartData = response
        }
      },
      showDetail(row){
        this.currentObject = row
        this.visible = true
      },
      pageChange(page) {
        this.pageForm.page = page - 1;
      }
    },
    beforeRouteEnter(to, from, next) {
      if(Vue.store.state.me === null) {
        next(vm => {
          vm.$router.push('login')
        })
      } else {
        let _check = Vue.store.state.me.authorities.map(({ authority }) => authority).includes('admin')
        if(_check){
          next()
        }else{
          next(vm => {
            vm.$router.push('/1vs1/detect')
          })
        }
      }
    },
    mounted() {
      this.loadPcs();
      this.loadDepts();
      this.loadMsg();
      this.loadRecords();
    }
  }
</script>
